import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  debug: true,
  whitelist: ['login'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

let middleware = [thunk];
if (!process.env.NODE_ENV.includes('production')) {
  /* eslint-disable global-require */
  const reduxLogger = require('redux-logger').default;
  /* eslint-enable global-require */
  middleware = [...middleware, reduxLogger];
}

const store = createStore(persistedReducer, applyMiddleware(...middleware));

export { store };
export const persistor = persistStore(store);

// 註冊一個回調函數，每次狀態變化時打印 Redux 狀態  開發時要打開!!
// store.subscribe(() => {
//   console.log('(開發時使用)Redux 全部狀態:', store.getState());
// });
